import moment from 'moment'
import { resolveAssetUrl } from '@src/utility/assetUrl'
import axios from 'axios'
import themeConfig from '@src/configs/themeConfig'
import dayjs from 'dayjs'
import { isEqual } from 'lodash'

const localWarehouse = localStorage.getItem('warehouse')
export const warehouse = localWarehouse ? JSON.parse(localWarehouse) : {}

// import _ from 'lodash'
export const convertDate = (listDate: string[], key: string, param: any) => {
  const object = listDate.find(d => d === key)
  if (object) {
    return moment(param).format('YYYY/MM/DD')
  }
  return param
}
export const getFirstLetter = (name?: string | undefined): string | undefined => {
  const normalizedString = name
    ?.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
  const firstLetters = normalizedString
    ?.split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
  return firstLetters ?? undefined
}
export const getCurrentMonthAndYear = () => {
  const now = new Date()
  const currentMonth = now.getMonth() + 1 // getMonth() returns 0-11, so add 1 to get 1-12
  const currnetYear = now.getFullYear()
  const date: any = new Date()
  const firstDayOfYear: any = new Date(date.getFullYear(), 0, 1)
  const pastDaysOfYear: any = (date - firstDayOfYear) / 86400000
  const currentWeek = Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7)
  return { currentMonth, currnetYear, currentWeek }
}
export const convertSpec = (data: any) => {
  const specAll = data.specificationCode1
    ?.concat(data?.specificationCode2 !== '' ? ',' : '', data?.specificationCode2)
    .concat(data?.specificationCode3 !== '' ? ',' : '', data?.specificationCode3)
    .concat(data?.specificationCode4 !== '' ? ',' : '', data?.specificationCode4)
    .concat(data?.specificationCode5 !== '' ? ',' : '', data?.specificationCode5)
    .concat(data?.specificationCode6 !== '' ? ',' : '', data?.specificationCode6)
    .concat(data?.specificationCode7 !== '' ? ',' : '', data?.specificationCode7)
    .concat(data?.specificationCode8 !== '' ? ',' : '', data?.specificationCode8)
    .concat(data?.specificationCode9 !== '' ? ',' : '', data?.specificationCode9)
    .concat(data?.specificationCode10 !== '' ? ',' : '', data?.specificationCode10)
  return specAll
}
export const convertSpecView = (data: any) => {
  const specAll = data.specificationCode1
    ?.concat(data?.specificationCode2 !== undefined ? ',' : '', data?.specificationCode2)
    .concat(data?.specificationCode3 !== undefined ? ',' : '', data?.specificationCode3)
    .concat(data?.specificationCode4 !== undefined ? ',' : '', data?.specificationCode4)
    .concat(data?.specificationCode5 !== undefined ? ',' : '', data?.specificationCode5)
    .concat(data?.specificationCode6 !== undefined ? ',' : '', data?.specificationCode6)
    .concat(data?.specificationCode7 !== undefined ? ',' : '', data?.specificationCode7)
    .concat(data?.specificationCode8 !== undefined ? ',' : '', data?.specificationCode8)
    .concat(data?.specificationCode9 !== undefined ? ',' : '', data?.specificationCode9)
    .concat(data?.specificationCode10 !== undefined ? ',' : '', data?.specificationCode10)
  return specAll
}
export const mapObject = (data: any, listObjectDate: any) => {
  const newObj: any = {}
  for (const [k, v] of Object.entries(data)) {
    newObj[k] = v === '' ? undefined : v
    if (listObjectDate?.length > 0) {
      if (listObjectDate.find((x: any) => x === k) && v) {
        newObj[k] = v ? moment(v).toISOString() : undefined
      }
    }
  }
  return newObj
}

export const downloadFile = async (path: string, fileName: string) => {
  const url = resolveAssetUrl(path)
  if (!url) {
    console.error('Invalid file path provided for download:', path)
    return
  }
  try {
    const response = await axios.get(url, { responseType: 'blob' })
    const dataUrl = URL.createObjectURL(new Blob([response.data]))

    const a = document.createElement('a')
    a.href = dataUrl
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    a.remove()
  } catch (error) {
    console.error('Error downloading file:', error)
  }
}

export const convertArrayWithIndent = (inputArray: any[], parentIndent = 0) => {
  if (inputArray) {
    return inputArray.map(item => {
      const indent = parentIndent

      if (item.children && item.children.length > 0) {
        item.children = convertArrayWithIndent(item.children, indent + 1)
      }

      return { ...item, indent }
    })
  } else {
    return []
  }
}
// ** Returns K format from a number
export const kFormatter = (num: any) => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = (html: any) => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = (date: any) => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}
export const getCurrentApp = () => {
  try {
    const productCode = process.env.REACT_APP_PRODUCT_CODE
    const listApp = localStorage.getItem('SHORT_LINK_APP')
    if (listApp) {
      return JSON.parse(listApp).find((x: { productCode: string }) => x.productCode === productCode)
    } else {
      return {}
    }
  } catch {
    return {}
  }
}
/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
// export const formatDate = (value: any, formatting: any = { month: 'short', day: 'numeric', year: 'numeric' }) => {
//   if (!value) { return value }
//   return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
// }

// ** Returns short month of passed date
export const formatDateToMonthShort = (value: any, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting: any = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// function padTo2Digits(num: any) {
//   return num.toString().padStart(2, '0')
// }

export const formatDate = (date: any) => {
  return moment(date).isValid() && date ? moment(date).format(themeConfig.system.dateFormatMoment) : undefined
}

export const formatDateTime = (date: any) => {
  return moment(date).isValid() && date ? moment(date).format(themeConfig.system.dateTimeFormatMoment) : undefined
}

export const mapObjectDate = (data: any, listObjectDate: any) => {
  const newObj: any = {}
  for (const [name, value] of Object.entries(data)) {
    newObj[name] = value
    if (listObjectDate.includes(name) && value) {
      newObj[name] = moment(value).toISOString()
    }
  }
  return newObj
}

export const setCookie = (cName: string, cValue: any, exDays: any) => {
  const d = new Date()
  d.setTime(d.getTime() + exDays * 24 * 60 * 60 * 1000)
  const expires = `expires=${d.toUTCString()}`
  document.cookie = `${cName}=${cValue}; ${expires};path=/`
}

export const getCookie = (cname: any) => {
  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}
export const deleteCookie = (cName: string) => {
  const expires = `expires=0`
  document.cookie = `${cName}=; ${expires};path=/`
}

export const deleteAllCookie = () => {
  const cookies = document.cookie.split(';')

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = `${name}=;expires=0"`
  }
}

export const nestArray = (items: any, id: any, link: string) => {
  return items
    .filter((item: any) => item[link] === id)
    .map((item: any) => ({
      ...item,
      children: nestArray(items, item.id, link)
    }))
}

export const flattenArray = (arr: any) => {
  if (!arr) {
    return []
  }
  return arr.reduce((r: any, { children, ...rest }: any) => {
    r.push(rest)
    if (children) {
      r.push(...flattenArray(children))
    }
    return r
  }, [])
}

export const formatBytes = (props: any, decimals = 2) => {
  if (!+props.size) {
    return '0 Bytes'
  }
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(props.size) / Math.log(k))
  return `${parseFloat((props.size / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export const getDuplicate2Array = (source: any, target: any) => {
  const dup: any = []
  const rs = [...target]
  for (let i = 0; i < source.length; i++) {
    const srcObj: any = source[i]
    const tarObj: any = rs.find(function (obj: any) {
      return obj.name === srcObj.name
    })

    if (tarObj) {
      dup.push(srcObj)
    }
  }
  return dup
}

export const getDjf2Array = (source: any, target: any) => {
  const rs = [...target]
  for (let i = 0; i < source.length; i++) {
    const srcObj: any = source[i]
    const tarObj: any = rs.find(function (obj: any) {
      return obj.name === srcObj.name
    })

    if (!tarObj) {
      rs.push(srcObj)
    }
  }
  return rs
}

// find object by value of key
export const getObject = (array: any, key: any, value: any) => {
  let o
  array.some(function iter(a: any) {
    if (a[key] === value) {
      o = a
      return true
    }
    return Array.isArray(a.children) && a.children.some(iter)
  })
  return o
}
export const deleteObjByValue = (arr: any[], field: any) => {
  const rs = arr.filter(function (el) {
    if (!el[field] || el[field] === '') {
    } else {
      return el[field]
    }
  })
  return rs
}
// export const msToHMS = (ms: number) => {
//   const seconds : number = ms / 1000
//   const hours : number = parseInt(seconds / )
//   seconds = seconds % 3600
//   const minutes : number = parseInt(seconds / 60)
//   seconds = seconds % 60
//   return seconds
// }
// ** Checks if an object is empty (returns boolean)
export const parseNumber = (d: any) => {
  if (d === null || d === undefined || d === '') {
    return 0
  }
  return +d
}

export const reverseString = (str: any): string => {
  return str === '' ? '' : reverseString(str.substr(1)) + str.charAt(0)
}

export const getString = (str: string, regex: any) => {
  if (str.length > 0) {
    const revers = reverseString(str)
    const index = revers.search(regex)
    const preRs = revers.substring(0, index)
    const rs = reverseString(preRs)
    return rs
  }
  return ''
}
export const generateUUID = () => {
  // Public Domain/MIT
  let d = new Date().getTime() //Timestamp
  let d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0 //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0
      d = Math.floor(d / 16)
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0
      d2 = Math.floor(d2 / 16)
    }
    return (c === 'x' ? r : 0x3).toString(16)
  })
}

export const nestArray2 = (arr: any, parentKey: string) => {
  if (!arr) {
    return []
  }
  const ids = arr.map((x: any) => x.id)
  const result: any = arr
    .map((parent: any) => {
      const children: any = arr.filter((child: any) => {
        if (child.id !== child[parentKey] && child[parentKey] === parent.id) {
          return true
        }

        return false
      })

      if (children && children.length) {
        parent.child = children
      }

      return parent
    })
    .filter((obj: any) => {
      if (obj.id === obj[parentKey] || !ids.includes(obj[parentKey])) {
        // include ultimate parents and orphans at root
        return true
      }

      return false
    })

  return result
}

type ILocal = 'vi-VN' | 'en-US' | undefined
type ICurrencyCode = 'VND' | 'USD' | undefined

export const currency = (value: any, currencyCode: ICurrencyCode = undefined, local: ILocal = 'vi-VN') => {
  if (currencyCode) {
    const CUR = new Intl.NumberFormat(local, {
      style: 'currency',
      currency: currencyCode ? currencyCode : 'VND'
    })

    return value ? CUR.format(value) : 0
  } else {
    const CUR = new Intl.NumberFormat()

    return value ? CUR.format(value) : 0
  }
}

export const getContextPermission = (arr1: any, array2: any) => {
  const rs: any = []
  arr1.map((item: any) => {
    const find = array2.find((i: any) => item.action === i.id)
    if (find) {
      rs.push(item)
    }
  })
  return rs
}
export const toNumber = (num: any) => {
  if (!num) {
    return 0
  }
  return +num
}

export const checkThousandSeparator = (thousandSeparator: any, decimalSeparator: any) => {
  if (thousandSeparator) {
    if (decimalSeparator) {
      if (thousandSeparator === decimalSeparator) {
        return ','
      } else {
        return thousandSeparator
      }
    } else {
      return thousandSeparator
    }
  } else {
    return ','
  }
}

export const checkDecimalSeparator = (thousandSeparator: any, decimalSeparator: any) => {
  if (decimalSeparator) {
    if (thousandSeparator) {
      if (thousandSeparator === decimalSeparator) {
        return '.'
      } else {
        return decimalSeparator
      }
    } else {
      return decimalSeparator
    }
  } else {
    return '.'
  }
}

export const calculateExchange = (value?: any, calculation?: string, rate?: any) => {
  if (calculation === '*') {
    return (value ?? 0) * (rate ?? 1)
  } else if (calculation === '/') {
    return (value ?? 0) / (rate ?? 1)
  } else {
    return value ?? 0
  }
}

export const conCateStringFromObj = (obj: any) => {
  let result = ''
  for (const key in obj) {
    if (obj[key]) {
      result += `${obj[key]}-`
    }
  }
  // Remove the trailing dash
  result = result.slice(0, -1)
  return result
}

export const isEmpty = (d: any): boolean => {
  if (d === null || d === undefined || d === '') {
    return true
  }
  return false
}

export const updateArrayByKey = (arr: any[], element: any, key: string) => {
  if (arr) {
    return arr.map(item => {
      if (item[key] === element[key]) {
        return { ...item, ...element }
      } else if (item.children && item.children.length > 0) {
        item.children = updateArrayByKey(item.children, element, key)
      }
      return item
    })
  } else {
    return []
  }
}

export const convertDayjsToDate = (dateString: string, format: string) => {
  const dayjsDate = dayjs(dateString, format)
  if (!dayjsDate.isValid()) {
    throw new Error('Invalid date or format')
  }
  return dayjsDate.toDate()
}

export const convertDateToDayjs = (date: Date | undefined, format: string) => {
  const dateValue = date ? dayjs(date).format(format) : null
  return dateValue ? dayjs(dateValue, format) : null
}

export const isArraysEqual = (arr1: any[], arr2: any[]): boolean => {
  if (arr1.length !== arr2.length) {
    return false
  }
  return arr1.every((element, index) => element === arr2[index])
}

export const isNullOrUndefined = (d: any) => {
  if (d === null || d === undefined) {
    return true
  }
  return false
}

export const numberFormat = (number: any, currecyCode?: string, afterDot?: number) => {
  const obj: any[] = [
    { code: 'VND', format: 'vi-VN' },
    { code: 'USD', format: 'en-US' },
    { code: 'EUR', format: 'en' },
    { code: 'CNY', format: 'zh-Hant' },
    { code: 'HKD', format: 'zh-HK' },
    { code: 'JPY', format: 'ja-JP' },
    { code: 'CHF', format: 'de-CH' },
    { code: 'NZD', format: 'en-NZ' },
    { code: 'GBP', format: 'en-GB' },
    { code: 'AUD', format: 'en-AU' },
    { code: 'CAD', format: 'en-CA' },
    { code: 'ZAR', format: 'en-ZA' }
  ]
  const currecy: any = obj.find((a: any) => a.code === currecyCode)
  return new Intl.NumberFormat(currecy?.format ?? 'vi-VN', { style: 'decimal', maximumFractionDigits: afterDot ?? 0 }).format(isNullOrUndefined(number) || isNaN(number) ? 0 : number)

}

export function findDifferencesArray(initialArray?: any[], finalArray?: any[]) {
  if (initialArray) {
    const deletedElements = initialArray?.filter(
      initialItem => !finalArray?.some(finalItem => finalItem.id === initialItem.id)
    )

    const newElements = finalArray?.filter(
      finalItem => !initialArray?.some(initialItem => initialItem.id === finalItem.id)
    )

    const modifiedElements = finalArray?.filter(finalItem => {
      const originalItem = initialArray?.find(initialItem => initialItem?.id === finalItem?.id)
      return originalItem && !isEqual(originalItem, finalItem)
    })

    if (newElements?.length === 0 &&
      modifiedElements?.length === 0 &&
      deletedElements?.length === 0) {
      return null
    }
    return {
      newElements,
      modifiedElements,
      deletedElements
    }
  }
}
